import Samples from '../../templates/Samples/Samples';
import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @typedef {Object} content
 *
 * @augments {Component<Props>}
 */
class SamplesView extends Component {
	render () {
		const { content } = this.props;
		return <Samples content={content} />;
	}
}

export default withLanguageContext(SamplesView);



// WEBPACK FOOTER //
// ./src/components/views/SamplesView/SamplesView.js